<template>
	<div class="w-full pointer-events-auto h-full">
		<div
			class="flex h-full w-full flex-col bg-white shadow-xl py-6 px-4 sm:p-6"
		>
			<div class="flex flex-col h-full">
				<div class="flex items-start justify-between">
					<h2 id="slide-over-title" class="text-lg font-medium py-0">
						{{ $t("wishlist.title") }} ({{ wishlistProducts?.ItemCount ?? 0 }})
					</h2>
					<div class="ml-3 flex h-7 items-center">
						<button
							type="button"
							class="-m-2 p-2 text-gray-700"
							@click="emits('close')"
						>
							<span class="sr-only">{{ $t("Close panel") }}</span>
							<XMarkIcon class="w-6 h-6" />
						</button>
					</div>
				</div>

				<div
					v-if="wishlistProducts?.Items?.length"
					class="flex-1 min-h-0 overflow-y-auto -mx-4 sm:-mx-6"
				>
					<div class="flex flex-col gap-2 px-4 sm:px-6">
						<ProductCardWishlist
							v-for="product in wishlistProducts?.Items"
							:key="product.Id"
							:product="product"
							:picture-size="`w-[7.5rem]`"
							@close-modal="emits('close')"
						/>
					</div>
				</div>
				<div
					v-else
					class="flex-1 min-h-0 text-center flex flex-col justify-center"
				>
					<h4 class="mb-2 font-medium text-2xl text-empty-cart-header">
						{{ $t("wishlist.empty_title") }}
					</h4>
					<p class="mb-6 text-base text-empty-cart-desc">
						{{ $t("wishlist.empty_paragraph") }}
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { XMarkIcon } from "@heroicons/vue/24/solid";
import { inject } from "vue";
import { storeToRefs } from "pinia";
import type { SharedModal } from "../Shared/SharedModal.vue";

const emits = defineEmits<{
	(e: "close"): void;
}>();
inject<SharedModal>("modal") as SharedModal;
const { wishlistProducts } = storeToRefs(useWishlistStore());
</script>
